"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dd_api_1 = __importDefault(require("../dd-api"));
class DDCpaasApi extends dd_api_1.default {
    constructor(api_host, client) {
        super(api_host, client);
    }
    async sendTransactionalSms(body) {
        const response = await this.post(`/cpaas/messages`, body);
        return response.data;
    }
}
exports.default = DDCpaasApi;
//# sourceMappingURL=dd-cpaas-api.js.map